export default __webpack_public_path__ + "static/media/EMLITE.f3c49dd2.png";